import { useState, useEffect } from "react";
import { Paintbrush, Check } from "lucide-react";
import { Popover, PopoverTrigger, PopoverContent } from "@/components/ui/popover";

const LIGHT_FG = "#334155";
const DARK_FG = "#e5e7eb";

const COLORS = [
  { key: "white", label: "White", value: "#ffffff", dark: false },
  { key: "slate", label: "Slate", value: "#f1f5f9", dark: false },
  { key: "indigo", label: "Indigo", value: "#e0e7ff", dark: false },
  { key: "sky", label: "Sky", value: "#e0f2fe", dark: false },
  { key: "emerald", label: "Emerald", value: "#d1fae5", dark: false },
  { key: "amber", label: "Amber", value: "#fef3c7", dark: false },
  { key: "rose", label: "Rose", value: "#ffe4e6", dark: false },
  { key: "violet", label: "Violet", value: "#ede9fe", dark: false },
  { key: "charcoal", label: "Charcoal", value: "#1e293b", dark: true },
  { key: "midnight", label: "Midnight", value: "#0f172a", dark: true },
  { key: "navy", label: "Navy", value: "#172554", dark: true },
  { key: "indigo-dark", label: "Deep Indigo", value: "#312e81", dark: true },
  { key: "violet-dark", label: "Deep Violet", value: "#4c1d95", dark: true },
  { key: "plum", label: "Plum", value: "#581c87", dark: true },
  { key: "emerald-dark", label: "Deep Emerald", value: "#064e3b", dark: true },
  { key: "teal-dark", label: "Deep Teal", value: "#134e4a", dark: true },
  { key: "maroon", label: "Maroon", value: "#7f1d1d", dark: true },
  { key: "coffee", label: "Coffee", value: "#3f2d1d", dark: true },
];

export function applyMenuColor(key) {
  const c = COLORS.find((x) => x.key === key) || COLORS[0];
  const root = document.documentElement;
  root.style.setProperty("--menu-bg", c.value);
  root.style.setProperty("--menu-fg", c.dark ? DARK_FG : LIGHT_FG);
  root.setAttribute("data-menu-dark", c.dark ? "1" : "0");
}

export default function MenuColorSwitcher() {
  const [colorKey, setColorKey] = useState(() => localStorage.getItem("menu_bg_color") || "white");

  useEffect(() => { applyMenuColor(colorKey); localStorage.setItem("menu_bg_color", colorKey); }, [colorKey]);

  return (
    <Popover>
      <PopoverTrigger asChild>
        <button className="p-2.5 rounded-lg text-slate-600 hover:bg-slate-100" title="Menu & ribbon color" data-testid="menu-color-btn">
          <Paintbrush size={20} />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-64 p-3" align="end" data-testid="menu-color-popover">
        <div className="text-xs font-semibold text-slate-500 mb-2">Menu &amp; Ribbon Color</div>
        <div className="grid grid-cols-6 gap-2">
          {COLORS.map((c) => (
            <button key={c.key} onClick={() => setColorKey(c.key)} title={c.label} data-testid={`menu-color-${c.key}`}
              className="relative w-8 h-8 rounded-lg border border-slate-200 flex items-center justify-center transition-transform hover:scale-110"
              style={{ backgroundColor: c.value }}>
              {colorKey === c.key && <Check size={14} className={c.dark ? "text-white" : "text-slate-700"} />}
            </button>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
}
